import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import ReactPlayer from 'react-player'

// import other components within the same project here
import Config from "../../../Config.jsx";

import {
  Stage,
  Layer,
  Circle,
} from 'react-konva';

import { withTheme } from '@material-ui/core/styles';

class PinEditor extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      db_x: 0.0,
      db_y: 0.0,
      pos_x: 0.0,
      pos_y: 0.0,
      maxCanvasSize: 0,
      canvasWidth: 960,
      canvasHeight: 480,
      mediaWidth: 0,
      mediaHeight: 0,
      isDragging: false,
      trigger_time: 0,
      stageData: this.props.root.refs.stageViewerPage.refs.stageDetailView.state.stageData,
    };
    autoBind(this);

    if (this.props.db_x) {
      this.state.db_x = this.props.db_x;
    }
    if (this.props.db_y) {
      this.state.db_y = this.props.db_y;
    }
    this.updateScreenPointPosition();

    if (this.props.parent.props.playbackData) {
      this.state.trigger_time = this.props.parent.props.playbackData['trigger_time'];
    }
    else {
      this.state.trigger_time = this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime;
    }
  }

  componentDidMount() {
    let boundingRect = this.refs.div.getBoundingClientRect();
    let width = boundingRect.width;
    let height = width / 2;
    this.setState({
      maxCanvasSize: width,
    });
    this.state.maxCanvasSize = width;

    this.setCanvasSize(width, height);
  }

  setCanvasSize(width, height) {
    this.setState({
      canvasWidth: width,
      canvasHeight: height,
    });
    this.state.canvasWidth = width;
    this.state.canvasHeight = height;

    if (this.state.stageData['panorama_format'] == 1) {
      height /= 2;
    }
    else if (this.state.stageData['panorama_format'] == 2) {
      width /= 2;
    }
    this.setState({
      mediaWidth: width,
      mediaHeight: height,
    });
    this.state.mediaWidth = width;
    this.state.mediaHeight = height;

    this.updateScreenPointPosition();
  }

  onImgLoad({target:img}) {
    let width = img.naturalWidth;
    let height = img.naturalHeight;
    let aspectRatio = width / height;
    if (width > height) {
      width = this.state.maxCanvasSize;
      height = width / aspectRatio;
    }
    else {
      height = this.state.maxCanvasSize;
      width = height * aspectRatio;
    }

    this.setCanvasSize(width, height);
  }

  updateScreenPointPosition() {
    let screenPt = this.dbPointToScreenPoint({x: this.state.db_x, y: this.state.db_y});
    this.setState({
      pos_x: screenPt.x,
      pos_y: screenPt.y,
    });
    this.state.pos_x = screenPt.x;
    this.state.pos_y = screenPt.y;
  }

  handleDragStart = e => {
    this.setState({
      isDragging: true,
    });
    this.state.isDragging = true;
  }

  handleDragEnd = e => {
    this.setState({
      isDragging: false,
    });
    this.state.isDragging = false;
    let x = e.target.getAttr("x");
    let y = e.target.getAttr("y");

    let dbPoint = this.screenPointToDbPoint({x: x, y: y});
    if (this.props.parent.onPinPositionUpdate) {
      this.props.parent.onPinPositionUpdate(dbPoint);
    }
  }

  dragBoundFunc(pos) {
    if (pos.x < 0) {
      pos.x = 0;
    }
    if (pos.y < 0) {
      pos.y = 0;
    }
    if (pos.x > this.state.mediaWidth) {
      pos.x = this.state.mediaWidth;
    }
    if (pos.y > this.state.mediaHeight) {
      pos.y = this.state.mediaHeight;
    }
    return {
      x: pos.x,
      y: pos.y,
    }
  }

  dbPointToScreenPoint(pt) {
    let halfBgWidth = this.state.mediaWidth / 2.0;
    let halfBgHeight = this.state.mediaHeight / 2.0;
    return {
      x: pt.x * halfBgWidth + halfBgWidth,
      y: halfBgHeight - pt.y * halfBgHeight,
    }
  }

  screenPointToDbPoint(pt) {
    let result = {
      x: 0,
      y: 0,
    }
    let halfBgWidth = this.state.mediaWidth / 2.0;
    let halfBgHeight = this.state.mediaHeight / 2.0;
    result.x = (pt.x - halfBgWidth) / halfBgWidth;
    result.y = -(pt.y - halfBgHeight) / halfBgHeight;
    return result;
  }

  onVideoReady() {
    if (this.state.trigger_time >= 0) {
      this.refs.videoPlayer.seekTo(this.state.trigger_time);
      this.setState({ trigger_time: -1 });
    }
  }

  render() {
    let fileUrl = "";
    let thumbnailUrl = "";
    if (this.state.stageData['movie_list'].length > 0) {
      let movieData = this.state.stageData['movie_list'][0];
      fileUrl = Config.BASE_PATH() + movieData['path'];
      thumbnailUrl = Config.BASE_PATH() + movieData['tn_path'];
    }

    let croppedPosition = "";
    if (this.state.stageData['panorama_format'] == 1) {
      croppedPosition = "0 0%";
    }
    else if (this.state.stageData['panorama_format'] == 2) {
      croppedPosition = "0% 0"
    }

    return (
      <div ref="div" style={{width:'100%', height:'100%', position:'relative', justifyContent:'center', display:'flex'}}>
        <div style={{width:this.state.mediaWidth, height:this.state.mediaHeight, position:'relative'}}>
          <div style={{width:'100%', height:'100%', position:'absolute', justifyContent:'center', display:'flex'}}>
            <If condition={this.state.stageData['kind'] == 0}>
              <Then>
                <div style={{display:'none'}}>
                  <img
                    onLoad={this.onImgLoad}
                    src={thumbnailUrl}
                  />
                </div>
                <div style={{backgroundColor:'Black', overflow:'hidden'}}>
                  <ReactPlayer
                    ref="videoPlayer"
                    width={this.state.canvasWidth}
                    height={this.state.canvasHeight}
                    url={fileUrl}
                    onReady={this.onVideoReady}
                  />
                </div>

              </Then>
              <Else>
                <img
                  style={{
                    width:this.state.mediaWidth,
                    height:this.state.mediaHeight,
                    objectFit:'cover',
                    objectPosition:croppedPosition,
                  }}
                  ref="img"
                  onLoad={this.onImgLoad}
                  src={thumbnailUrl}
                />
              </Else>
            </If>
          </div>
          <div style={{width:'100%', height:'100%', position:'absolute', justifyContent:'center', display:'flex'}}>
            <Stage width={this.state.mediaWidth} height={this.state.mediaHeight}>
              <Layer>
                <Circle
                  x={this.state.pos_x}
                  y={this.state.pos_y}
                  radius={10}
                  fill={this.props.theme.palette.secondary.main}
                  stroke="white"
                  strokeWidth={2}
                  opacity={this.state.isDragging? 0.5 : 0.9}
                  perfectDrawEnabled={false}
                  draggable
                  onDragStart={this.handleDragStart}
                  onDragEnd={this.handleDragEnd}
                  dragBoundFunc={(pos)=>this.dragBoundFunc(pos)}
                />
              </Layer>
            </Stage>
          </div>
        </div>
      </div>
    )
  }
}

export default withTheme(PinEditor);
